import React from 'react';

import SsoHandoff from '@views/Authentication/SsoHandoff';

function SsoHandoffPage() {
  return <SsoHandoff />;
}

export default SsoHandoffPage;
